import { PageResponse, type PageSummary } from '@diana/contracts';
import { useQueries } from '@tanstack/react-query';

import { useAdminApi } from '../../app/AdminApiContext.js';
import { pageCover } from './page-cover.js';

/** Optional, read-only thumbnails cannot block the list or populate the editor's draft cache. */
export function usePageCovers(pages: readonly PageSummary[]) {
  const api = useAdminApi();
  const queries = useQueries({
    queries: pages.map((page) => ({
      queryKey: ['page-cover', page.id, page.revision],
      queryFn: async () =>
        pageCover((await api.get(`/api/v1/admin/pages/${page.id}`, PageResponse)).page) ?? null,
      staleTime: 30_000,
      refetchOnMount: 'always' as const,
      retry: false,
    })),
  });
  return Object.fromEntries(
    pages.map((page, index) => [page.id, queries[index]?.data ?? undefined]),
  );
}
